import i18n from "@/i18n";
import { getTitle, getTitlePrefix } from "@/utils/title";
import {
  IMLIVE_SORT_FREE_CHAT,
  LAYOUT_BLANK,
  LAYOUT_MAIN,
  LAYOUT_V2,
  LAYOUT_V2_BLOG,
  V2_HEADER_THEME_NUDE,
  V2_HEADER_THEME_PEACH,
} from "@/utils/variables";
import { useUserStore } from "@/store/user";
import { RouteLocationNormalized } from "vue-router";
import HomePage from "@/pages/home/index.vue";
import CustomPage from "@/pages/custom-page/index.vue";

export default [
  {
    path: "/",
    component: HomePage,
    meta: {
      title: () => {
        const year = new Date().getFullYear();
        // eslint-disable-next-line
        // @ts-ignore
        return `${getTitlePrefix()} \u00A9 ${year} - ${i18n.global.t(
          "german porn | amateur porn | amateur sex videos | german amateurs | private amateurs",
        )}`;
      },
      layout: LAYOUT_V2,
    },
  },
  {
    path: "/forgot_password",
    component: () => import("@/pages/forgot-password/index.vue"),
    meta: {
      title: () => getTitle("Forgot Password"),
      layout: LAYOUT_V2,
    },
  },
  {
    path: "/reset_password",
    component: () => import("@/pages/reset-password/index.vue"),
    meta: {
      title: () => getTitle("Password recovery"),
      layout: LAYOUT_V2,
    },
  },
  {
    path: "/join",
    redirect: "/",
  },
  {
    path: "/videos",
    props: (route: RouteLocationNormalized) => {
      const props: {
        page?: number;
        order?: string | null;
        tags?: number[];
        query?: string | null;
      } = {};

      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      props.order = (route.query.order as string) ?? null;
      props.tags = route.query.tags ? (route.query.tags as string).split(",").map((id: string) => parseInt(id)) : [];
      props.query = (route.query.query as string) ?? null;
      return props;
    },
    component: () => import("@/pages/videos/index.vue"),
    meta: {
      title: () => getTitle("Videos"),
      requiresAuth: true,
    },
  },
  {
    path: "/feeds",
    component: () => import("@/pages/feeds/index.vue"),
    meta: {
      title: () => getTitle("Feeds"),
      requiresAuth: true,
    },
  },
  {
    path: "/recent_updates",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      return props;
    },
    component: () => import("@/pages/updates/index.vue"),
    meta: {
      title: () => getTitle("Recent updates"),
      requiresAuth: true,
    },
  },
  {
    path: "/update/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/update/index.vue"),
    meta: {
      title: () => getTitle("Update"),
      requiresAuth: true,
    },
  },
  {
    path: "/models",
    props: (route: RouteLocationNormalized) => {
      const props: {
        page?: number;
        order?: string | null;
      } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      props.order = (route.query.order as string) ?? null;
      return props;
    },
    component: () => import("@/pages/models/index.vue"),
    meta: {
      title: () => getTitle("Models"),
      requiresAuth: true,
    },
  },
  {
    path: "/profile/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/model-profile/index.vue"),
    meta: {
      title: () => getTitle("Model Profile"),
      requiresAuth: true,
    },
  },
  {
    path: "/shoots",
    props: (route: RouteLocationNormalized) => {
      const props: {
        page?: number;
        order?: string | null;
      } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      props.order = (route.query.order as string) ?? null;
      return props;
    },
    component: () => import("@/pages/shoots/index.vue"),
    meta: {
      title: () => getTitle("Shoots"),
      requiresAuth: true,
    },
  },
  {
    path: "/shoot/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/shoot/index.vue"),
    meta: {
      title: () => getTitle("Shoot"),
      requiresAuth: true,
    },
  },
  {
    path: "/shoot/:galleryId/images/:chapterId",
    props: (route: RouteLocationNormalized) => {
      return {
        galleryId: parseInt(route.params.galleryId as string),
        chapterId: parseInt(route.params.chapterId as string),
      };
    },
    component: () => import("@/pages/shoot-images/index.vue"),
    meta: {
      title: () => getTitle("Shoot Images"),
      requiresAuth: true,
    },
  },
  {
    path: "/cameras",
    props: (route: RouteLocationNormalized) => {
      const props: {
        page?: number;
        filters?: number[];
        order?: string | null;
        leaveCameraName?: string | null;
        exitCode?: number;
        showHint?: boolean;
      } = {};

      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;

      props.filters = route.query.filters ? (route.query.filters as string).split(",").map((item: string) => parseInt(item)) : [];

      props.order = Number(route.query.hint) ? IMLIVE_SORT_FREE_CHAT : ((route.query.order as string) ?? null);

      props.leaveCameraName = (route.query.camera as string) ?? null;

      props.exitCode = parseInt(route.query.exit_code as string);

      props.showHint = Boolean(Number(route.query.hint));

      return props;
    },
    component: () => import("@/pages/cameras/index.vue"),
    meta: {
      title: () => getTitle("Live Cams"),
      requiresAuth: true,
      lawLimited: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/camera/:name",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
      };
    },
    component: () => import("@/pages/camera-profile/index.vue"),
    meta: {
      title: () => getTitle("Live Cams - Camera Profile"),
      requiresAuth: true,
      lawLimited: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/camera/:name/photos",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
      };
    },
    component: () => import("@/pages/camera-photos/index.vue"),
    meta: {
      title: () => getTitle("Live Cams - Camera Photos"),
      requiresAuth: true,
      lawLimited: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/camera/:name/videos",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
      };
    },
    component: () => import("@/pages/camera-videos/index.vue"),
    meta: {
      title: () => getTitle("Live Cams - Camera Videos"),
      requiresAuth: true,
      lawLimited: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/playdates",
    component: () => import("@/pages/playdates/index.vue"),
    meta: {
      title: () => getTitle("Playdates"),
      requiresAuth: true,
    },
  },
  {
    path: "/private-playdate/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        type: "private",
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/playdate/index.vue"),
    meta: {
      title: () => getTitle("Private Playdate"),
      requiresAuth: true,
      requiresPremium: true,
    },
  },
  {
    path: "/public-playdate/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        type: "public",
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/playdate/index.vue"),
    meta: {
      title: () => getTitle("Public Playdate"),
      requiresAuth: true,
      requiresPremium: true,
    },
  },
  {
    path: "/netiquette",
    component: () => import("@/pages/playdate-netiquette/index.vue"),
    meta: {
      title: () => getTitle("Ersties Playdate Netiquette for Viewers"),
      requiresAuth: true,
    },
  },
  {
    path: "/playdate-faq",
    component: () => import("@/pages/playdate-faq/index.vue"),
    meta: {
      title: () => getTitle("Playdate FAQ"),
      requiresAuth: true,
    },
  },
  {
    path: "/favourite-models",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      return props;
    },
    component: () => import("@/pages/favourite-models/index.vue"),
    meta: {
      title: () => getTitle("Favourite models"),
      requiresAuth: true,
    },
  },
  {
    path: "/favourite-shoots",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      return props;
    },
    component: () => import("@/pages/favourite-shoots/index.vue"),
    meta: {
      title: () => getTitle("Favourite shoots"),
      requiresAuth: true,
    },
  },
  {
    path: "/favourite-videos",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      return props;
    },
    component: () => import("@/pages/favourite-videos/index.vue"),
    meta: {
      title: () => getTitle("Favourite videos"),
      requiresAuth: true,
    },
  },
  {
    path: "/favourite-images",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      return props;
    },
    component: () => import("@/pages/favourite-images/index.vue"),
    meta: {
      title: () => getTitle("Favourite images"),
      requiresAuth: true,
    },
  },
  {
    path: "/favourite-cams",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};
      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;
      return props;
    },
    component: () => import("@/pages/favourite-cams/index.vue"),
    meta: {
      title: () => getTitle("Favourite Camgirls"),
      requiresAuth: true,
      lawLimited: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/user-profile",
    component: () => import("@/pages/user-profile/index.vue"),
    meta: {
      title: () => getTitle("Member Area"),
      requiresAuth: true,
    },
  },
  {
    path: "/playdates/request-private-playdate/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/private-playdate-request/index.vue"),
    meta: {
      title: () => getTitle("Request a private playdate"),
      requiresAuth: true,
      requiresPremium: true,
      lawLimited: true,
    },
  },
  {
    path: "/playdates/extend-playdate/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/private-playdate-extend/index.vue"),
    meta: {
      title: () => getTitle("Your Private Playdate has finished"),
      requiresAuth: true,
      requiresPremium: true,
    },
  },
  {
    path: "/user-profile/settings",
    component: () => import("@/pages/user-profile-settings/index.vue"),
    meta: {
      title: () => getTitle("Member Area"),
      requiresAuth: true,
    },
  },
  {
    path: "/messages",
    props: (route: RouteLocationNormalized) => {
      const props: { page?: number } = {};

      props.page = route.query.page ? Math.max(1, parseInt(route.query.page as string)) : 1;

      return props;
    },
    component: () => import("@/pages/messages/index.vue"),
    meta: {
      title: () => getTitle("Messages"),
      requiresAuth: true,
    },
  },
  {
    path: "/messages/ersties-hq",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
      };
    },
    component: () => import("@/pages/ersties-messages/index.vue"),
    meta: {
      title: () => getTitle("Messages"),
      requiresAuth: true,
    },
  },
  {
    path: "/messages/:name",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
      };
    },
    component: () => import("@/pages/camera-offline-dialog/index.vue"),
    meta: {
      title: () => getTitle("Messages"),
      requiresAuth: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/playdate-messages/:id",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/playdate-offline-dialog/index.vue"),
    meta: {
      title: () => getTitle("Playdate offline Messages"),
      requiresAuth: true,
    },
  },
  {
    path: "/playdate-chat-replay",
    props: (route: RouteLocationNormalized) => {
      return {
        token: route.query.token ?? "",
      };
    },
    component: () => import("@/pages/playdate-chat-replay/index.vue"),
    meta: {
      title: () => getTitle("Playdate chat replay"),
      layout: LAYOUT_BLANK,
    },
  },
  {
    path: "/free-chat/:name",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
        free: true,
      };
    },
    component: () => import("@/pages/camera-chat/index.vue"),
    meta: {
      title: () => getTitle("Live Cams - Camera Live Chat"),
      requiresAuth: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/chat/:name",
    props: (route: RouteLocationNormalized) => {
      return {
        name: route.params.name,
        free: false,
      };
    },
    component: () => import("@/pages/camera-chat/index.vue"),
    meta: {
      title: () => getTitle("Live Cams - Camera Live Chat"),
      requiresAuth: true,
      cameraFraudRestricted: true,
    },
  },
  {
    path: "/paywall",
    component: () => import("@/pages/paywall/index.vue"),
    meta: {
      title: () => getTitle("Activate Your Membership"),
      requiresAuth: true,
    },
  },
  {
    path: "/community_guidelines",
    component: () => import("@/pages/community-guidelines/index.vue"),
    meta: {
      title: () => getTitle("Community guidelines"),
      requiresAuth: true,
    },
  },
  {
    path: "/blog",
    props: (route: RouteLocationNormalized) => {
      return {
        title: route.query.title,
        category: route.query.category,
      };
    },
    component: () => import("@/pages/blog/index.vue"),
    meta: {
      layout: LAYOUT_V2_BLOG,
      title: () => getTitle("Ersties Blog"),
      v2headerTheme: V2_HEADER_THEME_NUDE,
    },
  },
  {
    path: "/lecker_blog",
    props: (route: RouteLocationNormalized) => {
      return {
        title: route.query.title,
        category: route.query.category,
      };
    },
    component: () => import("@/pages/blog/index.vue"),
    meta: {
      layout: LAYOUT_V2_BLOG,
      title: () => getTitle("Ersties Blog"),
      v2headerTheme: V2_HEADER_THEME_NUDE,
    },
  },
  {
    path: "/blog/:alias",
    props: (route: RouteLocationNormalized) => {
      return {
        alias: route.params.alias,
      };
    },
    component: () => import("@/pages/blog-post/index.vue"),
    meta: {
      layout: LAYOUT_V2_BLOG,
      title: () => getTitle("Ersties Blog"),
      v2headerTheme: V2_HEADER_THEME_PEACH,
    },
  },
  {
    path: "/lecker_blog/:alias",
    props: (route: RouteLocationNormalized) => {
      return {
        alias: route.params.alias,
      };
    },
    component: () => import("@/pages/blog-post/index.vue"),
    meta: {
      layout: LAYOUT_V2_BLOG,
      title: () => getTitle("Ersties Blog"),
      v2headerTheme: V2_HEADER_THEME_PEACH,
    },
  },
  {
    path: "/welcome/:id",
    name: "landing",
    props: (route: RouteLocationNormalized) => {
      return {
        id: parseInt(route.params.id as string),
      };
    },
    component: () => import("@/pages/landing/index.vue"),
    meta: {
      layout: LAYOUT_V2,
      title: () => getTitle(),
    },
  },
  {
    path: "/contact-us",
    component: () => import("@/pages/contact-us/index.vue"),
    meta: {
      title: () => getTitle("Contact Us"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/friends",
    component: () => import("@/pages/friends/index.vue"),
    meta: {
      title: () => getTitle("Our Friends"),
      requiresAuth: true,
    },
  },
  {
    path: "/agb",
    component: () => import("@/pages/agb/index.vue"),
    meta: {
      title: () => getTitle("2257 Notice / Legal"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/report",
    component: () => import("@/pages/report/index.vue"),
    meta: {
      title: () => getTitle("Content Removal"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/dmca",
    component: () => import("@/pages/dmca/index.vue"),
    meta: {
      title: () => getTitle("DMCA"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/prohibited_content",
    component: () => import("@/pages/prohibited-content/index.vue"),
    meta: {
      title: () => getTitle("Prohibited Content"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/apply",
    component: () => import("@/pages/apply-models/index.vue"),
    meta: {
      title: () => getTitle("In a nutshell:"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/sitemap",
    component: () => import("@/pages/sitemap/index.vue"),
    meta: {
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/about_us",
    component: () => import("@/pages/about-us/index.vue"),
    meta: {
      title: () => getTitle("About Us"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/test_videos",
    component: () => import("@/pages/test-videos/index.vue"),
    meta: {
      title: () => getTitle("Test videos"),
      layout: () => {
        const isLoggedIn = useUserStore().isLoggedIn;
        return isLoggedIn ? LAYOUT_MAIN : LAYOUT_V2;
      },
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "CustomPage",
    component: CustomPage,
    meta: {
      layout: LAYOUT_BLANK,
      title: () => getTitle(),
    },
  },
];
